module.exports = __webpack_public_path__ + "static/media/green-stroke.140dae5b.svg";